$(window).on("load", function() {

    $('.moment-maker .quiz__campaign-endpoint-blocks').masonry({
        itemSelector: '.block',
        columnWidth: '.block-sizer',
        percentPosition: true
    });

    //As spaceBetween not being set globally, per campaign, unset and reset this nasty way
    if( document.querySelector('.swiper-container') ) {
        var relatedSwiper = document.querySelector('.swiper-container').swiper;
        relatedSwiper.destroy();
    }

    new Swiper('.moment-maker .quiz__campaign__endpoint-related-carousel', {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        loop: true,
        slidesPerView: 3,
        spaceBetween: 0,
        speed: 500,
        autoplay: true,
        breakpoints: {
            480: {
                slidesPerView: 1
            },
            1000: {
                slidesPerView: 2
            }
        }
    });

});

$(document).ready(function(){
    $(".quiz__campaign").on("click", ".basket-add",function(e){
        e.preventDefault();
        let url = $(this).attr('href');
        navigation.addToCart(event, url);
    });
})


// WEBPACK FOOTER //
// ./services/russellhobbs/subdomains/cdn/js/quiz-campaign.custom.js